module.exports = "<div class=\"onesite-base copyright\" ng-bind-html=\"copyrightFooter\"></div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/copyright/copyright-template.html
 ** module id = 914
 ** module chunks = 1
 **/